import { useState, useEffect, useCallback } from 'react';
import { devDateTimeService } from '@/services/devDateTimeService';

/**
 * Hook to get current date/time that respects dev override
 * Automatically re-renders when override changes
 */
export function useDevDateTime() {
  const [, forceUpdate] = useState({});

  useEffect(() => {
    const unsubscribe = devDateTimeService.subscribe(() => {
      forceUpdate({});
    });
    return unsubscribe;
  }, []);

  const now = useCallback(() => devDateTimeService.now(), []);
  const nowTimestamp = useCallback(() => devDateTimeService.nowTimestamp(), []);
  const setOverride = useCallback((date: Date) => devDateTimeService.setOverride(date), []);
  const clearOverride = useCallback(() => devDateTimeService.clearOverride(), []);

  return {
    now,
    nowTimestamp,
    isOverrideEnabled: devDateTimeService.isOverrideEnabled(),
    overrideDate: devDateTimeService.getOverrideDate(),
    setOverride,
    clearOverride,
    isDevMode: devDateTimeService.isDevMode(),
  };
}
